// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Chatbot/index.css
// module id = 2275
// module chunks = 0